<div fxLayout="row" fxLayoutAlign="space-between start">
  <div class="alert-header">Urgent Information for Brokers</div>
  <div (click)="onCancel()" fxShow.xs="false" fxShow.sm="false">
    <span class="close-text"> Close X </span>
  </div>
  <div (click)="onCancel()" fxHide.gt-sm="true">
    <span class="close-text"> X </span>
  </div>
</div>

<mat-divider class="divider-spacer"></mat-divider>
<mat-dialog-content class="alert-container">
  <div
    fxLayout="column"
    fxLayout.md="row"
    fxLayoutGap="20px"
    class="alert-list"
    *ngFor="let alertList of data"
  >
    <div fxLayout="row" fxLayout.lt-md="column" fxFlex="100">
      <div fxFlex.lt-md="100" fxFlex="10" class="alert-icon-conatiner">
        <div [ngClass]="getClass(alertList.lob)" class="icon-wrap"></div>
      </div>
      <div fxFlex.lt-md="100" fxFlex="90">
        <div
          *ngIf="alertList.body"
          class="alert-content-body alert-content-header"
          [innerHtml]="
            alertList.body.substring(
              0,
              alertLength +
                alertList.body.trim().length -
                textLength(alertList.body)
            )
          "
        ></div>
      </div>
    </div>
  </div>
</mat-dialog-content>
